import { call, select } from 'redux-saga/effects';

import config from '@epi-config';
import { downloadFileAuthenticated } from '@epi-helpers/DownloadFileHelper';
import { getCustomerNumber } from '@epi-selectors/api';

import { Authorize } from '../constants/authorize';

import { getRequest, postRequest } from './ApiRepository';

const { enableDepositsUpdate, depositUpdateAllowedIds } = config;

function getAllowDepositUpdate(companyId) {
  return enableDepositsUpdate || depositUpdateAllowedIds.includes(companyId);
}

export function* getCompanyAccounts() {
  return yield call(
    getRequest,
    `${config.apiHost}/api/company-accounts`,
    Authorize.Always
  );
}

export function* getCompanyMetadata() {
  return yield call(
    getRequest,
    `${config.apiHost}/api/company-metadata`,
    Authorize.Always
  );
}

export function* getCompanyTransactions(query) {
  return yield call(
    getRequest,
    `${config.apiHost}/api/company-accounts/transactions`,
    Authorize.Always,
    { data: query }
  );
}

export function* depositCompanyAccount(payload) {
  const customerNumber = yield select(getCustomerNumber);

  return yield call(
    postRequest,
    getAllowDepositUpdate(customerNumber)
      ? `${config.apiHost}/api/deposit-orders`
      : `${config.apiHost}/api/company-accounts/deposits`,
    Authorize.Always,
    payload
  );
}

export function getReceiptForDepositOrder(depositId) {
  return downloadFileAuthenticated(
    `${config.apiHost}/api/company-accounts/deposits/${depositId}/receipt`,
    'receipt.pdf'
  );
}

export function getReceiptForTransaction(transactionId) {
  return downloadFileAuthenticated(
    `${config.apiHost}/api/company-accounts/transactions/${transactionId}/receipt`,
    'receipt.pdf'
  );
}
